import './App.css';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import { Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import AdminHome from './components/admin/AdminHome';
import Users from './components/admin/Users';
import Projects from './components/admin/Projects';
import PrivateRoute from './components/auth/PrivateRoute';
import UserDetails from './components/admin/UserDetails';
import Subscriptions from './components/admin/Subscriptions';
import Logs from './components/admin/Logs';
import AppSettings from './components/admin/AppSettings';
import Content from './components/admin/Content';
import PaymentOrders from './components/admin/PaymentOrders';
import PaymentDetails from './components/PaymentDetails';
import ScrollToHash from './components/ScrollToHash';
import SaleAgents from './components/admin/SaleAgents';
import ActivationCodes from './components/admin/ActivationCodes';



function App({ isLoggedIn }) {

  return (
    <div className="App">

      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />

        {/* Payment Details Route 
        
        <Route path="/payment" element={<PaymentDetails />} />
        */}





        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route
          path="/admin"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <AdminHome />
            </PrivateRoute>
          }
        />


        <Route
          path="/admin/users"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <Users />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/users/:id"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <UserDetails />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/expenses"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <Projects />
            </PrivateRoute>
          }
        />



        <Route
          path="/admin/subscriptions"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <Subscriptions />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/activation-codes"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <ActivationCodes />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/sale-agents"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <SaleAgents />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/payment-orders"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <PaymentOrders />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/content"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <Content />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/settings"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <AppSettings />
            </PrivateRoute>
          }
        />



        <Route
          path="/admin/logs"
          element={
            <PrivateRoute isLoggedIn={isLoggedIn}>
              <Logs />
            </PrivateRoute>
          }
        />


        <Route path="*" element={<Home />} />

      </Routes>


    </div>
  );
}

export default App;
